var map = {
	"./Card.js": 5,
	"./Cookies.js": 6,
	"./Filter.js": 7,
	"./Header.js": 8,
	"./articleSlider.js": 10,
	"./cardAdvertising.js": 11,
	"./cardGrid.js": 12,
	"./magazineSlider.js": 13,
	"./mainMenu.js": 14,
	"./newsletterForm.js": 15,
	"./searchForm.js": 16,
	"./sideMenu.js": 17,
	"./sideNavAccordion.js": 18,
	"./singleBack.js": 19,
	"./singleLike.js": 20,
	"./singleSharer.js": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;